import { render, staticRenderFns } from "./SoftwareLogs.vue?vue&type=template&id=6a7b9c1c&"
import script from "./SoftwareLogs.vue?vue&type=script&lang=js&"
export * from "./SoftwareLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports